import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantProjectFormStats = (token, id) => {
    return fetch(`${apiUrl}tenant_project_form_stats/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantProjectFormStats
